import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("iframe", {
    width: "100%",
    height: "800px;",
    src: _ctx.link,
    frameborder: "0"
  }, "\r\n    ", 8, _hoisted_1))
}